module.exports = __webpack_public_path__ + "img/288.a830bf60.jpg";